// user_id → profiles.id for the members a page is about to link to.
//
// Signal rows and proposal evidence name members by user_id (the auth id), but
// /profiles/show/:id resolves profiles.id — a different value in every row. One
// `in` query per set of ids, keyed on the sorted ids so a re-render with the
// same members does not refetch. An id with no profile is simply absent, and
// profileHref() sends that row to the member list instead of an empty page.

import { useEffect, useState } from 'react'
import { supabaseClient } from '../../lib/supabaseClient'

export function useProfileIds(userIds: readonly string[]): ReadonlyMap<string, string> {
  const key = [...new Set(userIds)].sort().join(',')
  const [profileIds, setProfileIds] = useState<ReadonlyMap<string, string>>(() => new Map())

  useEffect(() => {
    if (!key) return
    let live = true
    void (async () => {
      const { data } = await supabaseClient
        .from('profiles').select('id, user_id').in('user_id', key.split(','))
      if (!live) return
      setProfileIds(new Map(
        ((data ?? []) as { id: string; user_id: string | null }[])
          .filter((p) => p.user_id)
          .map((p) => [p.user_id as string, p.id]),
      ))
    })()
    return () => { live = false }
  }, [key])

  return profileIds
}
